import { Builder, IWith } from '../utils';

class TaskDataBuilder extends Builder<Presentation.Data.Task, {}> {}

export class TaskBuilder {
  public static new(): IWith<Presentation.Data.Task, { id: string }> {
    return new TaskDataBuilder({}).with('id', 'xxx');
  }
}
